import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var VsdxShortcutSvg = function VsdxShortcutSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M21.147 6.5 17 2.354V6.25c0 .138.113.25.25.25z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M6.5 10.204A9 9 0 0 1 11 18a8.96 8.96 0 0 1-.935 4H21.25a.25.25 0 0 0 .25-.25V7h-4.25a.75.75 0 0 1-.75-.75V2H6.75a.25.25 0 0 0-.25.25z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#605E5C",
      fillRule: "evenodd",
      d: "m17.073 1.72 4.707 4.707c.142.142.22.33.22.53V21.75a.75.75 0 0 1-.75.75H9.796q.142-.245.269-.5H21.25a.25.25 0 0 0 .25-.25V7h-4.25a.75.75 0 0 1-.75-.75V2H6.75a.25.25 0 0 0-.25.25v7.954a9 9 0 0 0-.5-.268V2.25a.75.75 0 0 1 .75-.75h9.793c.199 0 .39.08.53.22m4.073 4.78L17 2.354V6.25a.25.25 0 0 0 .25.25z",
      clipRule: "evenodd",
      opacity: 0.64
    }), /*#__PURE__*/_jsx("path", {
      fill: "#185ABD",
      fillRule: "evenodd",
      d: "M2 9v-.5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-1.014q.015-.248.014-.5a9 9 0 0 0-9-9",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M8.589 11.869q.433.465.799.99L10.5 10H9.245z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "M4.313 23.583q-1.793 0-3.053-1.245T0 19.295q0-1.27.647-2.288a4.36 4.36 0 0 1 1.725-1.57H0V14h5.39v5.39H3.954v-2.97a2.72 2.72 0 0 0-1.797.934 2.8 2.8 0 0 0-.719 1.917q0 1.201.839 2.038a2.78 2.78 0 0 0 2.037.837z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#185ABD",
      d: "M17.25 13a.25.25 0 0 1-.25-.25v-1.5h-.5v1.5a.25.25 0 0 1-.25.25h-1v.5h2.5a.25.25 0 0 1 .25.25v1.5h.5v-1.5a.75.75 0 0 0-.75-.75z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#41A5EE",
      d: "M14 11.5h1.5V15H14z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#103F91",
      d: "m14.747 9.75 2-2 2.002 2-2.001 2.002z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#2B7CD3",
      d: "M18.25 18.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5"
    })]
  });
};
export var VsdxShortcut = function VsdxShortcut(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: VsdxShortcutSvg
  }));
};